module.exports = __webpack_public_path__ + "assets/img/hyx_3.9abf3c38.png";